import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogRefreshTokenComponent } from './dialog-refresh-token.component';

@Injectable({
  providedIn: 'root'
})
export class DialogRefreshTokenService {

  constructor(private dialog: MatDialog) { }

  openConfirmRefreshTokenDialog(){
    const dialogRef = this.dialog.open(DialogRefreshTokenComponent,{
      width: '590px',
      disableClose: true,
    })
    return dialogRef;
    }
}
